export class MainteInfo{
  isMainte: boolean = false
  loginPageText: string = ""
  isDispHeaderText: boolean = false
  isDispLoginText: boolean = false
  headerText: string = ""
  isStudentLoginRestriction: boolean = false


  constructor(mainteInfos: any[]){
    if (mainteInfos.length == 0) {
      return;
    }
    var isMainteArry = mainteInfos.filter(x => x.key == "is_mainte");
    var loginPageTextArry = mainteInfos.filter(x => x.key == "mainte_info_login_page_text");
    var isDispHeaderTextArry = mainteInfos.filter(x => x.key == "is_dist_mainte_info_header_text");
    var mainteHeaderTextArry = mainteInfos.filter(x => x.key == "mainte_info_header_text");
    var isStudentLoginRestrictionArry = mainteInfos.filter(x => x.key == "is_student_login_restriction");
    var studentLoginRestrictionTextArry = mainteInfos.filter(x => x.key == "student_login_restriction_text");

    const isStudentSite = window.location.href.indexOf("student_site") != -1;

    this.isMainte = isMainteArry.length > 0 && isMainteArry[0].value == "1";
    this.isStudentLoginRestriction = isStudentLoginRestrictionArry.length > 0 && isStudentLoginRestrictionArry[0].value == "1";
    this.isDispHeaderText = isDispHeaderTextArry.length > 0 && (isDispHeaderTextArry[0].value == "1" || (isDispHeaderTextArry[0].value == "2" && !isStudentSite));
    this.isDispLoginText = isDispHeaderTextArry.length > 0 && isDispHeaderTextArry[0].value == "1";
    this.headerText = mainteHeaderTextArry.length > 0 ? mainteHeaderTextArry[0].value : "";

    if(this.isMainte && loginPageTextArry.length > 0){
      this.loginPageText = loginPageTextArry[0].value
    }else if(this.isStudentLoginRestriction && studentLoginRestrictionTextArry.length > 0){
      this.loginPageText = studentLoginRestrictionTextArry[0].value
    }else{
      this.loginPageText = "";
    }
  }
}